import React from 'react';
import { ArrowRight, Calendar, BookOpen, MessageCircle, CheckCircle } from 'lucide-react';

const STEPS = ['Watch', 'Read', 'Reflect', 'Discuss', 'Attend'];

export const ProductPreview = () => {
    const today = new Date().toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
    return (
        <div className="relative mx-auto w-full max-w-md" data-testid="product-preview" aria-label="Preview of a lesson in The Room">
            <div className="rounded-[2rem] border border-border/60 bg-card shadow-2xl p-4 sm:p-5 space-y-4">
                <div className="flex items-center justify-between px-1">
                    <span className="text-[11px] uppercase tracking-widest font-semibold text-muted-foreground">Good morning</span>
                    <span className="text-[11px] text-muted-foreground">Sample group</span>
                </div>
                <div className="rounded-2xl p-5 space-y-4 text-white" style={{ background: 'linear-gradient(135deg, #4A5D3A 0%, #3D4D30 50%, #354428 100%)' }}>
                    <div className="flex items-center justify-between text-xs">
                        <span className="uppercase tracking-widest font-semibold text-white/70">This Week</span>
                        <span className="flex items-center gap-1 text-white/70"><Calendar className="w-3 h-3" />{today}</span>
                    </div>
                    <div>
                        <p className="text-xl font-semibold" style={{ fontFamily: "'Fraunces', serif" }}>Faith and Grace</p>
                        <p className="text-sm text-white/70">Introduction to the Gospel · Lesson 2</p>
                    </div>
                    <div className="flex gap-1.5">
                        {STEPS.map((s, i) => <div key={s} className={`h-1.5 flex-1 rounded-full ${i < 2 ? 'bg-white' : 'bg-white/25'}`} />)}
                    </div>
                    <div className="flex items-center justify-between text-sm">
                        <span className="text-white/70 text-xs">2 of 5 steps</span>
                        <span className="flex items-center gap-1.5 font-semibold">Continue <ArrowRight className="w-4 h-4" /></span>
                    </div>
                </div>
                <div className="grid grid-cols-2 gap-3">
                    <div className="rounded-xl bg-muted/50 p-3 space-y-1">
                        <BookOpen className="w-4 h-4 text-primary" />
                        <p className="text-xs font-semibold">Reading plan</p>
                        <p className="text-[11px] text-muted-foreground">Romans 5:1-11</p>
                    </div>
                    <div className="rounded-xl bg-muted/50 p-3 space-y-1">
                        <CheckCircle className="w-4 h-4 text-primary" />
                        <p className="text-xs font-semibold">Discussion</p>
                        <p className="text-[11px] text-muted-foreground">3 questions</p>
                    </div>
                </div>
                <div className="rounded-xl border border-border/60 p-3 flex items-start gap-2.5">
                    <div className="w-7 h-7 rounded-full bg-primary/15 text-primary text-[10px] font-bold flex items-center justify-center shrink-0">SM</div>
                    <div className="min-w-0">
                        <p className="text-xs font-semibold flex items-center gap-1"><MessageCircle className="w-3 h-3 text-primary" /> Group chat</p>
                        <p className="text-xs text-muted-foreground line-clamp-2">The reading plan this week was really helpful. See everyone Sunday!</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ProductPreview;
